import React from 'react';

export type Crumb = { label: string; href?: string };

type BreadcrumbsContextValue = {
  crumbs: Crumb[];
  setBreadcrumbs: (items: Crumb[]) => void;
  headerActions: React.ReactNode | null;
  setHeaderActions: (actions: React.ReactNode | null) => void;
  rightHeaderActions: React.ReactNode | null;
  setRightHeaderActions: (actions: React.ReactNode | null) => void;
};

const BreadcrumbsContext = React.createContext<BreadcrumbsContextValue | undefined>(undefined);

export const BreadcrumbsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [crumbs, setCrumbs] = React.useState<Crumb[]>([]);
  const [headerActions, setHeaderActions] = React.useState<React.ReactNode | null>(null);
  const [rightHeaderActions, setRightHeaderActions] = React.useState<React.ReactNode | null>(null);

  const setBreadcrumbs = React.useCallback((items: Crumb[]) => {
    setCrumbs(Array.isArray(items) ? items : []);
  }, []);

  const value = React.useMemo(() => ({ crumbs, setBreadcrumbs, headerActions, setHeaderActions, rightHeaderActions, setRightHeaderActions, }), [crumbs, headerActions, setBreadcrumbs, rightHeaderActions]);

  return (
    <BreadcrumbsContext.Provider value={value}>
      {children}
    </BreadcrumbsContext.Provider>
  );
};

export function useBreadcrumbs(): BreadcrumbsContextValue {
  const ctx = React.useContext(BreadcrumbsContext);
  if (!ctx) throw new Error('useBreadcrumbs must be used within BreadcrumbsProvider');
  return ctx;
}


